module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/planowanie.svg?61d4f707";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/planowanie.svg
// module id = 1866
// module chunks = 0